import React from 'react';
import { Award, Users, Clock, ShieldCheck } from 'lucide-react';

const AboutSection = () => {
  return (
    <section className="py-12 lg:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <img 
              src="/images/assets/team-3.jpg"
              alt="Professional HVAC technician"
              className="rounded-2xl shadow-xl w-full"
            />
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-emerald-600 text-white p-6 rounded-2xl shadow-xl hidden md:block">
              <div className="text-4xl font-heading font-bold">25+</div>
              <div className="text-sm">Years Experience</div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider">About Us</span>
            <h2 className="font-heading font-bold text-4xl md:text-5xl text-slate-900 mt-4 mb-6">
              About ComfortMaster
            </h2>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              For more than 25 years, our family-focused team has been dedicated to keeping homes and businesses comfortable with honest service, expert craftsmanship, and a commitment to doing things the right way. From residential service and replacement to new construction and light commercial projects, we take pride in building long-lasting relationships with the families, builders, and business owners we serve throughout our community.
            </p>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              Our foundation is built on continuous training, industry education, and strong family values. As active members of organizations like the Building Industry Association and the Indoor Air Quality Association, we stay at the forefront of comfort, efficiency, and indoor air quality standards so we can provide solutions our customers can trust for generations to come.
            </p>

            {/* Features */}
            <div className="grid grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <ShieldCheck className="w-6 h-6 text-emerald-600" />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">Licensed & Certified</h4>
                  <p className="text-sm text-slate-600">KY: #HM07021</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Users className="w-6 h-6 text-emerald-600" />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">Expert Team</h4>
                  <p className="text-sm text-slate-600">Certified technicians</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Clock className="w-6 h-6 text-emerald-600" />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">Fast Service</h4>
                  <p className="text-sm text-slate-600">Same-day available</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Award className="w-6 h-6 text-emerald-600" />
                </div>
                <div>
                  <h4 className="font-bold text-slate-900">Quality First</h4>
                  <p className="text-sm text-slate-600">Right the first time</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
